module.exports = __webpack_public_path__ + "img/33_22.d8e8ea4b.png";